import axios from 'axios';
import { useQuery, useMutation, useQueryClient } from 'react-query';


const API_BASE_URL = '/api';

export function useFetchReimbursementInvoiceReport(token) {
    return useQuery('ReimbursementReportDetails', async () => {
        const response = await axios.get('/api/reimbursement/invoices', {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    }, {
        enabled: !!token,
        staleTime: 2 * 60 * 1000,
        cacheTime: 10 * 60 * 1000,
        refetchOnWindowFocus: false,
    });
}